/**
 * The pack registry.
 *
 * v1 pointed `main.ts` at a single pack, which made "adding a jurisdiction is a
 * data drop, not a rewrite" an aspiration rather than a fact: a second pack
 * would not have been routed to, and would never have passed through
 * `npm run validate:pack`.
 *
 * Everything that needs to know what projects exist reads this list — the
 * router, the switcher, the validator and the build gate. Adding a
 * jurisdiction is one import and one array entry, and nothing else.
 */

import type { Pack } from '../src/engine/schema.js';
import pineIsland from './pine-island-mn/index.js';

export const packs: readonly Pack[] = [pineIsland];

/** The pack served at the bare domain. */
export const defaultSlug = 'pine-island';

export function packBySlug(slug: string): Pack | undefined {
  return packs.find((p) => p.meta.slug === slug);
}

export function knownSlugs(): string[] {
  return packs.map((p) => p.meta.slug);
}

/**
 * Never throws. An unknown slug falls back to the default rather than showing
 * an error page — a stale link to a renamed project should still land on
 * something readable.
 */
export function resolvePack(slug: string | null | undefined): Pack {
  const hit = slug ? packBySlug(slug) : undefined;
  return hit ?? packBySlug(defaultSlug) ?? packs[0]!;
}
